import React from 'react'
import { IconProps, IconWrapper } from './IconWrapper'
const renderIcon = (color: string) => {
    return (
        <>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M15.0303 10.4697C15.3232 10.7626 15.3232 11.2374 15.0303 11.5303L11.5303 15.0303C11.2374 15.3232 10.7626 15.3232 10.4697 15.0303L8.46967 13.0303C8.17677 12.7374 8.17677 12.2626 8.46967 11.9697C8.76256 11.6768 9.23743 11.6768 9.53033 11.9697L11 13.4393L13.9697 10.4697C14.2626 10.1768 14.7374 10.1768 15.0303 10.4697Z'
                fill={color}
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M12.9319 6.20831C11.3816 6.20831 10.0406 7.11064 9.40811 8.42212C9.23806 8.77473 8.82542 8.93724 8.46059 8.79528C7.96986 8.60433 7.4354 8.49919 6.87459 8.49919C4.45813 8.49919 2.49919 10.4581 2.49919 12.8746C2.49919 15.2911 4.45813 17.25 6.87459 17.25H18.5232C20.1677 17.25 21.5008 15.9169 21.5008 14.2724C21.5008 12.628 20.1677 11.2949 18.5232 11.2949C18.2557 11.2949 17.9974 11.33 17.7524 11.3954C17.5122 11.4596 17.2558 11.4005 17.0679 11.2378C16.8799 11.075 16.7849 10.8296 16.8141 10.5827C16.8321 10.4305 16.8413 10.2754 16.8413 10.1178C16.8413 7.95864 15.091 6.20831 12.9319 6.20831ZM8.38001 7.19402C9.34175 5.69973 11.0205 4.70831 12.9319 4.70831C15.8124 4.70831 18.1671 6.95976 18.3321 9.79889C18.3955 9.79622 18.4592 9.79487 18.5232 9.79487C20.9961 9.79487 23.0008 11.7995 23.0008 14.2724C23.0008 16.7453 20.9961 18.75 18.5232 18.75H6.87459C3.6297 18.75 0.999191 16.1195 0.999191 12.8746C0.999191 9.6297 3.6297 6.99919 6.87459 6.99919C7.39425 6.99919 7.89897 7.06684 8.38001 7.19402Z'
                fill={color}
            />
        </>
    )
}

export const CloudSuccess: React.FC<IconProps> = ({ color, size }) => <IconWrapper {...{ size, color, renderIcon }} />
